import {useUserContext} from '@hconnect/login'
import {LandingPage} from '@hconnect/uikit/src/lib2'
import React from 'react'
import {useNavigate} from 'react-router'

import {getUrl} from '../helpers'
import {ROUTES} from '../routes'

import {Api} from '@settings/api/api'

export const LoginPage: React.FC = () => {
  const navigate = useNavigate()
  const {loggedUser} = useUserContext()
  const redirectToAuthenticator = () => Api.loginFlow.startLoginProcess()

  if (loggedUser) {
    navigate(getUrl(ROUTES.BASE.path, {}))
    return null
  }

  return (
    <LandingPage
      onClickButton={() => void redirectToAuthenticator()}
      customLogoStyle={{
        height: '4rem'
      }}
    />
  )
}
